import { createSelector } from 'reselect'
import { CommonState } from '~/store/types'

const selectTourStore = (state: CommonState) => state.tour

export const selectCallback = createSelector([selectTourStore], state => state.callback)

export const selectIsTourRunning = createSelector(
  [selectTourStore],
  state => state.steps.length > 0 && state.isTourRunning
)

export const selectSteps = createSelector([selectTourStore], state => state.steps)
